import { render, staticRenderFns } from "./profile-create-document-template.vue?vue&type=template&id=4d6314f2&scoped=true&"
import script from "./profile-create-document-template.vue?vue&type=script&lang=js&"
export * from "./profile-create-document-template.vue?vue&type=script&lang=js&"
import style0 from "./profile-create-document-template.vue?vue&type=style&index=0&id=4d6314f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6314f2",
  null
  
)

export default component.exports